import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Column from "../components/Column";
import { logOff, destroy } from "actions/ui";

class NoChannelColumn extends React.Component {

	constructor(props) {
		super(props);

		this.handleCloseClick = this.handleCloseClick.bind(this);
	}

	handleCloseClick() {
		if (this.props.configuration.interface.channel.logOffOnCloseLast) {
			this.props.logOff();
		}
		if (this.props.configuration.interface.channel.destroyOnCloseLast) {
			this.props.destroy();
		}
	}

	render() {
		return <Column
			key="noChannel"
			id="noChannel"
			title={ this.props.configuration.interface.chat.title }
			className="wcFocused"
			closeButton={ <a href="#" onClick={ this.handleCloseClick } title={ this.props.i18n.close } className="wcFunctional wcClose" /> }
			closable={ true }
		>
			<div className="wcTabContent wcTabContentEmpty">
				<span className="wcEmptyChannel">{ this.props.i18nBase.noChannels }</span>
			</div>
		</Column>;
	}

}

NoChannelColumn.propTypes = {
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		i18nBase: state.configuration.i18n,
		i18n: state.application.i18n
	}), { logOff, destroy }
)(NoChannelColumn);